<template>
  <div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <p>VIP статус дейстувет</p>
    <p>До {{ endDate }}</p>

    <button type="button" @click="$router.push('/')" class="btn btn-light btn-own mb-3 align-self-center ">
      На главную
    </button>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
// <button type="button" @click="topUpCodeClick()" class="btn btn-light btn-own  mb-3 align-self-center ">Продлить
// </button>
// /api/side-pricing
export default {
  name: 'OrderVpnResult',
  data () {
    return {
      code: ''
    }
  },
  computed: {
    ...mapState('pricing', {
      orders: state => state.orders,
      invalidCode: state => state.invalidCode,
      endDate: state => state.endDate
    })
  },
  mounted () {
  },
  methods: {
    ...mapActions('pricing', {
      topUpCode: 'topUpCode',
      checkCode: 'checkCode'
    }),
    ...mapGetters('pricing', [
      'priceItems'
    ]),
    topUpCodeClick: function () {
      this.topUpCode()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.code {
  border-radius: 15px;
  width: 315px;

}

input.invalid {
  border-color: red;
}
</style>
